import { Link } from 'react-router-dom';

import { trackButtonClick } from '../../services/telemetry';
import {
  DEMO_REACH,
  SCORE_CTA_PRIMARY_BUTTON_CLASS,
  ScoreCtaInner,
} from './ScoreCtaBox';

/**
 * Guest project-page CTA: downloads are locked; sign up to keep the
 * result. Inner copy + button; the pages supply `ScoreCtaBox` chrome.
 */
export const GuestSaveBanner = ({ variant }: { variant: 'xml' | 'pdf' }) => (
  <ScoreCtaInner
    title={`This is a free preview for guest (${DEMO_REACH[variant]}).`}
    subtitle="Sign up to save, download, and subscribe for full access."
  >
    <Link
      to="/sign-up"
      onClick={() =>
        trackButtonClick('GuestProjectPage', 'Sign Up To Save Banner')
      }
      className={SCORE_CTA_PRIMARY_BUTTON_CLASS}
    >
      Create a free account
    </Link>
  </ScoreCtaInner>
);
